import React, { FC } from 'react';
import { INavItem } from "../index";
import { FontAwesomeIcon } from 'src/constants/fontAwesomeIcons';
import { Link } from 'react-router-dom';

import './Breadcrumb.scss';

interface IBreadcrumbProps {
    breadcrumb?: INavItem;
}

const Breadcrumb: FC<IBreadcrumbProps> = ({
    breadcrumb
}) => {

    return (
        <Link 
            className="ngt-breadcrumb"
            to={breadcrumb.url}
        >
            <FontAwesomeIcon icon={breadcrumb.icon} />
            <span>{breadcrumb.title}</span>
        </Link>
    );
}


export default Breadcrumb;